import React, { Component } from 'react';
import _ from 'lodash';
import { post, get } from '../../util/api';
import { Box, Button, TableBody, TableCell, TableHead, TableRow, Table, Typography, TextField } from '@mui/material';

class PausedSubsTable extends Component {
	state = {
		column: null,
		direction: null,
		loading: true,
		bulkRestartLoading: false,
		singleRestartLoading: {},
		bulkRestartFilter: 'all', // 'all', 'zero_limit'
		errMessage: '',
		bulkStatus: null, // arkaplandaki toplu işin son durumu
		infoMessage: '',
	};

	handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

	componentDidMount() {
		this.getData();
		// Sayfa açıldığında zaten çalışan bir toplu iş varsa göster (sekme kapansa da iş sürer)
		this.pollBulkStatus();
	}

	componentWillUnmount() {
		if (this.statusTimer) clearInterval(this.statusTimer);
	}

	async getData() {
		await get('/maytapi/admin/paused-subs').then((data) =>
			this.setState({
				data: _.orderBy(data.data, 'charge_id', 'desc'),
				loading: false,
			})
		);
	}

	refresh() {
		setTimeout(() => {
			window.location.reload(false);
		}, 1000);
	}

	// Arkaplandaki toplu işin durumunu çeker; çalışıyorsa 5 saniyede bir tekrar sorar.
	pollBulkStatus = () => {
		get('/maytapi/admin/reactiveAllPausedSubsStatus')
			.then((res) => {
				let status = res.data && res.data.data;
				if (!status) return;
				let wasRunning = this.state.bulkStatus && this.state.bulkStatus.running;
				this.setState({ bulkStatus: status });

				if (status.running && !this.statusTimer) {
					this.statusTimer = setInterval(this.pollBulkStatus, 5000);
				}
				if (!status.running && this.statusTimer) {
					clearInterval(this.statusTimer);
					this.statusTimer = null;
					if (wasRunning) {
						// İş bu sayfa açıkken bitti → listeyi tazele
						this.setState({
							infoMessage: `Toplu restart bitti: ${status.successful} başarılı, ${status.failed} başarısız. Özet WhatsApp'a gönderildi.`,
						});
						this.getData(); // tam reload yerine sadece listeyi tazele ki özet mesajı ekranda kalsın
					}
				}
			})
			.catch((error) => console.error('Bulk status error:', error));
	};

	// Bulk restart all paused subscriptions — servis işi arkaplanda başlatıp hemen dönüyor
	bulkRestartSubscriptions = () => {
		this.setState({ bulkRestartLoading: true, errMessage: '', infoMessage: '' });

		post('/maytapi/admin/reactiveAllPausedSubs', {
			filter: this.state.bulkRestartFilter,
		})
			.then((data) => {
				this.setState({ bulkRestartLoading: false });
				if (data.data.success) {
					this.setState({ infoMessage: data.data.message });
					this.pollBulkStatus();
				} else {
					this.setState({ errMessage: data.data.message || 'Bulk restart failed' });
				}
			})
			.catch((error) => {
				this.setState({ bulkRestartLoading: false, errMessage: 'Network error during bulk restart' });
				console.error('Bulk restart error:', error);
			});
	};

	// Single subscription restart
	singleRestartSubscription = (pid, chargeId, email) => {
		this.setState({
			singleRestartLoading: {
				...this.state.singleRestartLoading,
				[chargeId]: true,
			},
			errMessage: '',
		});

		post('/maytapi/admin/reactiveSingleSub', {
			pid: pid,
			subscription_id: chargeId,
		})
			.then((data) => {
				this.setState({
					singleRestartLoading: {
						...this.state.singleRestartLoading,
						[chargeId]: false,
					},
				});

				if (data.data.success) {
					alert(`Restart successful for ${email}!\n${data.data.message}`);
					this.refresh();
				} else {
					alert(`Restart failed for ${email}!\n${data.data.message || 'Unknown error'}`);
				}
			})
			.catch((error) => {
				this.setState({
					singleRestartLoading: {
						...this.state.singleRestartLoading,
						[chargeId]: false,
					},
				});
				alert(`Network error for ${email}: ${error.message}`);
				console.error('Single restart error:', error);
			});
	};

	updateSubscription = () => {
		this.setState({ btnloading: true });
		let { selectedChargeId, phoneQuantity, newPrice, planId } = this.state;

		post('/maytapi/admin/updatePausedSub', {
			charge_id: selectedChargeId,
			phone_limit: parseInt(phoneQuantity),
			new_price: parseFloat(newPrice),
			plan_id: planId,
		}).then((data) => {
			if (data.data.success) {
				this.setState({ btnloading: false });
				this.refresh();
			} else {
				this.setState({ btnloading: false, errMessage: data.data.error });
			}
		});
	};

	selectSubscription(value) {
		this.setState({
			selectedChargeId: value.charge_id,
			email: value.email,
			paddleEmail: value.paddle_email || value.email,
			phoneQuantity: value.phone_limit || 0,
			planId: value.plan_id || '',
			newPrice: value.new_price || 0,
		});
	}

	handleSort = (clickedColumn, data) => () => {
		const { column, direction } = this.state;
		if (column !== clickedColumn) {
			this.setState({
				column: clickedColumn,
				data: _.sortBy(data, [clickedColumn]),
				direction: 'ascending',
			});
			return;
		}

		this.setState({
			data: data.reverse(),
			direction: direction === 'ascending' ? 'descending' : 'ascending',
		});
	};

	TableLineCustom = (data) =>
		_.map(data, (val, index) => (
			<TableRow key={val && val.charge_id}>
				<TableCell>{index + 1}</TableCell>
				<TableCell>{val && val.email}</TableCell>
				<TableCell>{val && (val.data?.paddle_email || val.email)}</TableCell>
				<TableCell>{val && val.charge_id}</TableCell>
				<TableCell>{val && (val.settings?.phone_limit || 0)}</TableCell>
				<TableCell>{val && (val.data?.subscription_plan_id || val.settings?.plan_id || '-')}</TableCell>
				<TableCell>${val && (val.data?.amount || val.data?.new_price || 0)}</TableCell>
				<TableCell>
					<Box display="flex" gap={1}>
						<Button
							variant="contained"
							color="success"
							size="small"
							disabled={this.state.singleRestartLoading[val.charge_id]}
							onClick={() => this.singleRestartSubscription(val.pid, val.charge_id, val.email)}
						>
							{this.state.singleRestartLoading[val.charge_id] ? 'Restarting...' : 'Restart'}
						</Button>
					</Box>
				</TableCell>
			</TableRow>
		));

	render() {
		let { loading, data, column, direction, bulkStatus } = this.state;
		let bulkRunning = !!(bulkStatus && bulkStatus.running);
		console.log('paused subs data', data);

		// Data mapping for consistent structure
		let processedData = _.map(data, function (item) {
			return {
				charge_id: item.charge_id,
				email: item.email,
				paddle_email: item.data?.paddle_email || item.email,
				phone_limit: item.settings?.phone_limit || 0,
				plan_id: item.data?.subscription_plan_id || '',
				new_price: item.data?.new_price || 0,
				created_at: item.created_at,
				pid: item.pid,
				data: item.data,
				settings: item.settings,
			};
		});

		// Apply filter to displayed data based on dropdown selection
		let filteredData = processedData;
		if (this.state.bulkRestartFilter === 'zero_limit') {
			filteredData = _.filter(processedData, (item) => (item.phone_limit || 0) === 0);
		}

		if (loading) return <Box>Loading paused subscriptions...</Box>;

		return (
			<Box style={{ maxHeight: '800px' }}>
				<div style={{ padding: '0', overflow: 'auto' }}>
					<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
						<Typography variant="h4">
							Paused Subscriptions ({filteredData.length}/{processedData.length})
						</Typography>

						<Box display="flex" gap={2} alignItems="center">
							<TextField
								select
								size="small"
								label="Filter & Restart"
								value={this.state.bulkRestartFilter}
								onChange={(e) => this.setState({ bulkRestartFilter: e.target.value })}
								SelectProps={{ native: true }}
								style={{ minWidth: 150 }}
							>
								<option value="all">All Subscriptions</option>
								<option value="zero_limit">Zero Limit Only</option>
							</TextField>

							<Button
								variant="contained"
								color="primary"
								size="large"
								disabled={this.state.bulkRestartLoading || bulkRunning || filteredData.length === 0}
								onClick={this.bulkRestartSubscriptions}
								style={{ minWidth: 150 }}
							>
								{this.state.bulkRestartLoading ? 'Starting...' : bulkRunning ? 'Running in background...' : `Restart Visible (${filteredData.length})`}
							</Button>
						</Box>
					</Box>

					{(bulkRunning || this.state.infoMessage) && (
						<Typography
							variant="body2"
							gutterBottom
							style={{ padding: '10px', backgroundColor: '#e3f2fd', borderRadius: '4px', marginBottom: '10px' }}
						>
							{bulkRunning
								? bulkStatus.remote
									? '⏳ Restart denemeleri arkaplanda devam ediyor (başka sunucu instance’ında, detay burada yok). Bitince WhatsApp’a özet düşecek.'
									: `⏳ Restart denemeleri arkaplanda devam ediyor: ${bulkStatus.processed}/${bulkStatus.total}` +
									  ` — ✅ ${bulkStatus.successful} / ❌ ${bulkStatus.failed}` +
									  (bulkStatus.current ? ` — şu an: ${bulkStatus.current}` : '') +
									  '. Sayfayı kapatsanız da devam eder, bitince WhatsApp’a özet düşecek.'
								: this.state.infoMessage}
						</Typography>
					)}

					{this.state.errMessage && (
						<Typography
							color="error"
							variant="body2"
							gutterBottom
							style={{ padding: '10px', backgroundColor: '#ffebee', borderRadius: '4px', marginBottom: '10px' }}
						>
							Error: {this.state.errMessage}
						</Typography>
					)}

					<Table>
						<TableHead>
							<TableRow>
								<TableCell>#</TableCell>
								<TableCell style={{ cursor: 'pointer' }} onClick={this.handleSort('email', filteredData)}>
									Email {column === 'email' && (direction === 'ascending' ? '↑' : '↓')}
								</TableCell>
								<TableCell style={{ cursor: 'pointer' }} onClick={this.handleSort('paddle_email', filteredData)}>
									Paddle Email {column === 'paddle_email' && (direction === 'ascending' ? '↑' : '↓')}
								</TableCell>
								<TableCell style={{ cursor: 'pointer' }} onClick={this.handleSort('charge_id', filteredData)}>
									Charge ID {column === 'charge_id' && (direction === 'ascending' ? '↑' : '↓')}
								</TableCell>
								<TableCell style={{ cursor: 'pointer' }} onClick={this.handleSort('phone_limit', filteredData)}>
									Current Phone Limit {column === 'phone_limit' && (direction === 'ascending' ? '↑' : '↓')}
								</TableCell>
								<TableCell style={{ cursor: 'pointer' }} onClick={this.handleSort('plan_id', filteredData)}>
									Plan ID {column === 'plan_id' && (direction === 'ascending' ? '↑' : '↓')}
								</TableCell>
								<TableCell style={{ cursor: 'pointer' }} onClick={this.handleSort('new_price', filteredData)}>
									New Price {column === 'new_price' && (direction === 'ascending' ? '↑' : '↓')}
								</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>{this.TableLineCustom(filteredData)}</TableBody>
					</Table>
				</div>
			</Box>
		);
	}
}

export default PausedSubsTable;
